export default {
  name: 'slide-project-logo-on-white'
}



// WEBPACK FOOTER //
// ./src/includes/SlideProjectLogoOnWhite.js